import { Component, forwardRef, Inject, Input } from "@angular/core";
import { WorkOrder } from "../../model";
import { AuthenticationService } from "../../service/authentication.service";

@Component({
    selector: 'work-order-card',
    template: require('./work-order-card.component.html'),
    styles: [require('./work-order-card.component.css')]
})
export class WorkOrderCardComponent {

    newStyleManagerEnabled: boolean;

    constructor(@Inject(forwardRef(() => AuthenticationService)) private authenticationService: AuthenticationService) {
        this.newStyleManagerEnabled = this.authenticationService.isNewStyleManagerEnabled();
    }

    @Input() workOrder: WorkOrder;

}